import { NgModule } from '@angular/core';
import { LibEyeIconComponent } from './lib-eye-icon.component';

@NgModule({
  declarations: [LibEyeIconComponent],
  imports: [],
  exports: [LibEyeIconComponent],
})
export class LibEyeIconModule {}
